import * as CdsIcons from '@central-design-system/icons';

import { propsFactory } from '@components/utils';

import {
  makeGroupProps,
  makeTagProps,
  makeDirectionProps,
  makeDisabledProps,
  makeLocaleProps,
  makeThemeProps,
  makeGroupItemProps,
  makeLazyProps
} from '../../composable';

import type { PropType } from 'vue';
import type { TCdsIconsName } from '@central-design-system/icons';
import type { ITouchHandlers } from '@components/directives/touch';

export const makeSlideViewProps = propsFactory(
  {
    /**
     * Активирует переключение от последнего слайда к первому и наоборот
     */
    continuous: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Иконка для переключения на предыдущий слайд
     */
    prevIcon: {
      type: String as PropType<TCdsIconsName>,
      default: 'chevron-left',
      validator: (value: TCdsIconsName) => CdsIcons.allowedIcons.includes(value)
    },
    /**
     * Иконка для переключения на следующий слайд
     */
    nextIcon: {
      type: String as PropType<TCdsIconsName>,
      default: 'chevron-right',
      validator: (value: TCdsIconsName) => CdsIcons.allowedIcons.includes(value)
    },
    /**
     * Показывать стрелки для переключения между слайдами
     */
    showArrows: {
      type: [Boolean, String] as PropType<boolean | string>,
      default: undefined,
      validator: (value: any) => typeof value === 'boolean' || value === 'hover'
    },
    /**
     * Активирует переключение слайдов по свайпу
     */
    touch: {
      type: [Boolean, Object] as PropType<boolean | ITouchHandlers>,
      default: undefined
    },
    ...makeGroupProps(),
    ...makeTagProps(),
    ...makeDirectionProps(),
    ...makeDisabledProps(),
    ...makeLocaleProps(),
    ...makeThemeProps()
  },
  'slideView'
);

export const makeSlideViewItemProps = propsFactory(
  {
    reverseTransition: {
      type: [Boolean, String] as PropType<boolean | string>,
      default: undefined
    },
    transition: {
      type: [Boolean, String] as PropType<boolean | string>,
      default: undefined
    },

    ...makeGroupItemProps(),
    ...makeLazyProps(),
    ...makeDisabledProps()
  },
  'slideViewItem'
);
